import t from"../generateUtilityClass/generateUtilityClass.js";function e(e,r,a="Mui"){const i={};return r.forEach((r=>{i[r]=t(e,r,a)})),i}export{e as default};
//# sourceMappingURL=generateUtilityClasses.js.map
